/* eslint-disable no-use-before-define */
import React from 'react'
import { publish, ajax, hideModal } from '../../twd/twd'

export default ({params={}} = {}) => {

    const [searchName, setSearchName] = React.useState(params.description || '')
    const [saving, setSaving] = React.useState(false)

    let title = params.id
        ? 'Update search'
        : 'Save search'

    return <React.Fragment>
    <div className="modal-dialog modal-sm">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="saved-searches-save-search-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center vertical-offset-sm">{title}</h3>
            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">
                <label>Name</label>
                <input
                    data-name="saved-searches-save-search-name"
                    type="text"
                    className='form-control'
                    value={searchName}
                    disabled={saving}
                    onChange={(e) =>{
                        let s = e.target.value
                        setSearchName(s)
                    }}
                    />
            </div>
            </div>
        </div>

        <div className="modal-footer">
        <div className="row">
        <div className="col-centered-8">
            <button
                data-name="saved-searches-save-search-save"
                className="btn btn-block btn-lg btn-primary"
                type="button"
                disabled={!searchName || saving}
                onClick={async () => {
                    setSaving(true)
                    let p = Object.assign({}, params, {description:searchName.trim()})
                    let r = await onSave({params:p})
                    hideModal()
                    publish('search_saved', r)
                }}
            >Save</button>
            <button
                data-name="saved-searches-save-search-cancel"
                className="btn btn-block btn-lg btn-link"
                type="button"
                onClick={hideModal}
            >Cancel</button>
        </div>
        </div>
        </div>
    </div>
    </div>

    </React.Fragment>
}

const onSave = async ({params}) => {
    let qId = params.id
    let url = qId
        ? '/esb/portfolio/savedQueryUpdate'
        : '/esb/portfolio/savedQueryInsert'
    try {
        let {data} = ajax({
            url,
            method: 'POST',
            params
        })
        let r = (await data) || {}
        let s = r[0] || {}
        return {savedQueryId: s.id}
    } catch(e) {
    }
    return {}
}


// WEBPACK FOOTER //
// ./src/saved-searches/save-search/save-search.js